import React, { useState, useEffect } from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { Capacitor } from '@capacitor/core';

const AppStoreBanner: React.FC = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Modern iOS detection
    const isIOS = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };

    // Check if it's in standalone mode (added to home screen) or running in native app
    const isInStandaloneMode = () => {
      return (
        Capacitor.isNativePlatform() || // Check if running in native app
        ('standalone' in window.navigator &&
        // @ts-ignore: 'standalone' exists on iOS Safari
        window.navigator.standalone === true)
      );
    };

    // // Check if we should show the banner
    // const hasDismissed = localStorage.getItem('appStoreBannerDismissed');
    // setShowBanner(isIOS() && !isInStandaloneMode() && !hasDismissed);

    // Temporarily disable banner
    setShowBanner(false);
  }, []);

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('appStoreBannerDismissed', 'true');
  };

  const handleInstall = () => {
    // Replace with your actual App Store URL
    window.location.href = 'https://apps.apple.com/app/luminous-meditation/id123456789';
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-100 shadow-lg border-t border-gray-200 p-4 z-50">
      <div className="flex items-center justify-between max-w-screen-xl mx-auto">
        <div className="flex items-center space-x-4">
          <div className="w-12 h-12 rounded-xl bg-brand-primary/10 flex items-center justify-center">
            <SparklesIcon className="w-8 h-8 text-brand-primary" />
          </div>
          <div>
            <h3 className="font-medium text-brand-primary">Luminous App</h3>
            <p className="text-sm text-gray-600">Download the app to your iPhone</p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={handleInstall}
            className="bg-brand-primary text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-brand-primary/90 transition-colors"
          >
            Install
          </button>
          <button
            onClick={handleDismiss}
            className="text-gray-500 hover:text-gray-700 transition-colors"
            aria-label="Dismiss"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppStoreBanner;
